/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import { Question } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
export { AvatarDropdown, AvatarName, Footer, Question, SelectLang };

/**
 * 文件上传组件
 */
export { default as AvatarUpload } from './FileUpload/AvatarUpload';
export { default as CoverUpload } from './FileUpload/CoverUpload';
export { default as FileUpload } from './FileUpload/FileUpload';
